<!-- Loading state -->
<div class="loading-state" *ngIf="!resultReady">
  <qai-loading size="medium" />
  <span class="loading-label">{{
    "results.PROCESSING_RESULTS" | transloco
  }}</span>
</div>

<ng-container *ngIf="resultReady && translationLoaded">
  <!-- Hero -->
  <div class="hero">
    <div class="hero-text">
      <h2 class="hero-title">
        {{ "results.QUIZ_RESULTS_SUMMARY" | transloco }}
      </h2>
      <p class="hero-subtitle">
        {{
          embeddedQuizSummaryTranslationKey
            | transloco
              : {
                  stepNames: embeddedQuizReviewStepNamesText,
                  stepWord: embeddedQuizStepWord,
                  stepVerb: embeddedQuizStepVerb,
                  areaWord: embeddedQuizAreaWord,
                }
        }}
      </p>
    </div>

    <div class="hero-score">
      <div
        class="score-badge"
        [ngClass]="{
          success: criteriaScore > 0 && practiceScore >= criteriaScore,
          default: criteriaScore <= 0,
        }"
      >
        <div class="score-value">
          {{
            callScoreCalcType === calcTypeRatio5pt0min
              ? (practiceScore | number: "1.1-2")
              : callScoreCalcType === "RATIO_100PT_0MIN"
                ? (practiceScore | number: "1.0-2") + "%"
                : (practiceScore | number: "1.0-2")
          }}
        </div>
        <div class="score-label">
          {{ totalPositivePoints }}/{{ totalPoints }}
        </div>
      </div>
    </div>
  </div>

  <!-- Feedback Content -->
  <div class="feedback">
    <div class="content">
      <div class="questions">
        <div
          class="question-result"
          *ngFor="let question of guidedResults?.questions"
        >
          <div class="question">
            {{ question.name }}
            <div class="total-points">
              {{ question.practiceCallGuided.totalPositivePoints }} /
              {{ question.practiceCallGuided.totalPoints }}
            </div>
          </div>

          <div class="talking-points">
            <!-- Covered -->
            <div class="talking-point">
              <div class="talking-point-title covered">
                {{ "results.COVERED" | transloco }}
              </div>
              <div class="points">
                <div
                  class="points-list"
                  *ngIf="
                    question.practiceCallGuided.positiveContext.length > 0;
                    else emptyPositiveContext
                  "
                >
                  <div
                    class="point"
                    *ngFor="
                      let point of question.practiceCallGuided.positiveContext
                    "
                  >
                    <qai-icon
                      [kind]="'check-circle'"
                      [color]="'#3796A4'"
                      [size]="'15px'"
                    ></qai-icon>
                    {{ point }}
                  </div>
                </div>
                <ng-template #emptyPositiveContext>
                  <div class="message">
                    <strong>{{
                      "results.REVIEW_MISSED_TITLE" | transloco
                    }}</strong>
                    {{ "results.NO_TALKING_POINTS_COVERED" | transloco }}
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- Missed -->
            <div class="talking-point">
              <div class="talking-point-title missed">
                {{ "results.MISSED" | transloco }}
              </div>
              <div class="points">
                <div
                  class="points-list"
                  *ngIf="
                    question.practiceCallGuided.negativeContext.length > 0;
                    else emptyNegativeContext
                  "
                >
                  <div
                    class="point"
                    *ngFor="
                      let point of question.practiceCallGuided.negativeContext
                    "
                  >
                    <qai-icon
                      [kind]="'x-close'"
                      [color]="'#D92D20'"
                      [size]="'15px'"
                    ></qai-icon>

                    <div
                      class="underscore-list"
                      *ngIf="isTextUnderscore(point); else normalPoint"
                    >
                      <span
                        *ngFor="let char of point.split(' ')"
                        class="underscore"
                        [style.width.px]="char.length * 10"
                      ></span>
                    </div>
                    <ng-template #normalPoint>
                      <div
                        [ngClass]="{ 'hide-talking-points': !showMissedFacts }"
                      >
                        {{ showMissedFacts ? point : "" }}
                      </div>
                    </ng-template>
                  </div>
                </div>

                <ng-template #emptyNegativeContext>
                  <div class="quiz-result-success">
                    {{ "results.NONE_PERFECT" | transloco }}
                    <span class="checkmark">✓</span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
